import { Multiselect } from "multiselect-react-dropdown";
import React, { useEffect, useState, useRef } from "react";
import { Link,useHistory} from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import {
  Row,
  Card,
  Col,
  Button,
  Nav,
  Modal,
  Table,
  Dropdown,
  Alert,
  Spinner,
} from "react-bootstrap";
import swal from "sweetalert";
import MetisMenu from "metismenujs";
export default function ServiceableArea() {
  const history=useHistory()
  const objectArray1 = ["Go_Movers", "Go_Food", "Go_Taxi"];
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  const [spinner, setSpinner] = useState(true);
  const [category, setCategory] = useState("");
  const [show, setShow] = useState(false);
  const [show4, setShow4] = useState(false);
  const [pincodes, setpincodes] = useState([]);
  const [stateForSearch, setStateForSearch] = useState([]);
  const [showdistricts, setshowdistricts] = useState("false");
  const [showdictpincodes1, setshowdictpincodes1] = useState("false");
  const [showstates, setshowstates] = useState("true");
  const [statepincodes, setstatepincodes] = useState([]);
  const [districtForSearch, setDistrictForSearch] = useState([]);
  const [showdictpincodes, setshowdictpincodes] = useState([]);
  const [forSearch, setForSearch] = useState([]);
  const [pincodes1, setpincodes1] = useState([]);
  const [show1, setShow1] = useState(false);
  const [name, setName] = useState("");
  const [search, setSearch] = useState("");
  const [serviceData, setServiceData] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [serviceCategory, setServiceCategory] = useState("");
  const [servicePincode, setServicePincode] = useState("");
  const [updateService, setUpdateService] = useState(false);
  const [addExist, setAddExist] = useState("");
  const [addExistId, setAddExistId] = useState("");
  const duplicateCheck = [];
  const selection1 = (selectedValues) => {
    setCategory(selectedValues[0].category);
  };
  const selection2 = (selectedValues) => {
    setServiceCategory(selectedValues[0].category);
  };
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  const handleClose = () => {
    setShow(false);
    setshowstates("true");
    setshowdistricts("false");
    setshowdictpincodes1("false");
  };
  const handleClose1 = () => {
    setShow(false);
  };
  const handleClose2 = () => {
    setShow1(false);
  };
  const handleShow = (val, id) => {
    setshowstates("true");
    setshowdictpincodes1("false");
    setshowdistricts("false");
    if (val === "addExist") {
      setAddExistId(id);
      setAddExist(val);
    } else {
      setAddExistId("");
      setAddExist("");
    }
    setShow(true);
    axios.get(Baseurl.baseurl + `/go-pincode/get-all-pincodes`).then((res) => {
      setpincodes(res.data.pincodes);
      setStateForSearch(res.data.pincodes);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  };
  function getData() {
    axios
      .get(Baseurl.baseurl + `/go-service-area/get-all-service-area`)
      .then((res) => {
        setSpinner(false);
        setServiceData(res.data.serviceArea);
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  useEffect(() => {
    getData();
  }, []);
  const setitem = (id, name) => {
    if (id == "back") {
      setshowstates("true");
      setshowdistricts("false");
    } else {
      axios
        .get(Baseurl.baseurl + `/go-pincode/get-districts/${name}`)
        .then((res) => {
          setstatepincodes(res.data.districts);
          setDistrictForSearch(res.data.districts);
        })
        .catch((err) => {
          if(err.toString()==="Error: Network Error")
          {
            history.push('/offline')
          }
          else
          {
            history.push('/400')
          }
      })
      setshowstates("false");
      setshowdistricts("true");
    }
  };
  const setitemapi = (sname) => {
    axios
      .get(Baseurl.baseurl + `/go-pincode/get-districts/${sname}`)
      .then((res) => {
        if (addExist === "addExist") {
          var Pincodes = {  
            pincode: res.data.districts[0].PinCode,
          };
          axios
            .put(
              Baseurl.baseurl +
                `/go-service-area/add-new-pincode/${addExistId}`,
              Pincodes
            )
            .then((res) => {
              getData();
              swal("Pincode Updated", res.data.message, "success", {
                button: "Done",
                timer: 1000,
              });
              handleClose();
            })
            .catch((err) => {
              if(err.toString()==="Error: Network Error")
              {
                history.push('/offline')
              }
              else
              {
                history.push('/400')
              }
          })
        } else {
          var Pincodes = {
            pincode: res.data.districts[0].PinCode,
            name: `${name}`,
            category: `${serviceCategory}`,
          };
          axios
            .post(
              Baseurl.baseurl + `/go-service-area/add-service-area`,
              Pincodes
            )
            .then((res) => {
              getData();
              swal("Added", res.data.message, "success", {
                button: "Done",
                timer: 1000,
              });
              handleClose();
            })
            .catch((err) => {
              if(err.toString()==="Error: Network Error")
              {
                history.push('/offline')
              }
              else
              {
                history.push('/400')
              }
          })
        }
      });
  };
  const viewdict = (id) => {
    setshowstates("false");
    setshowdistricts("false");
    setshowdictpincodes1("true");
    axios.get(Baseurl.baseurl + `/go-pincode/get-pincode/${id}`).then((res) => {
      var pincode = res.data.pincodes.PinCode;
      // const obj = { ...pincode };
      var arrayOfObjs = pincode.map(function(val) {
        return { id: val };
      });
      setshowdictpincodes(arrayOfObjs);
      setForSearch(arrayOfObjs);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  };
  const sub = (id) => {
    setpincodes1(
      (oldArray) => oldArray.concat(id),
      () => {}
    );

    // var unique = [...new Set(number)];
  };
  function removeDuplicates(arr) {
    var counts = arr.reduce(function(counts, item) {
      counts[item] = (counts[item] || 0) + 1;
      return counts;
    }, {});
    return Object.keys(counts).reduce(function(arr, item) {
      if (counts[item] === 1) {
        arr.push(item);
      }
      if (counts[item] === 3) {
        arr.push(item);
      }
      return arr;
    }, []);
  }
  const addPin = () => {
    if (addExist === "addExist") {
      var Pincodes = {
        pincode: [...new Set(removeDuplicates(pincodes1))],
      };
      axios
        .put(
          Baseurl.baseurl + `/go-service-area/add-new-pincode/${addExistId}`,
          Pincodes
        )
        .then((res) => {
          getData();
          swal("Pincode Updated", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          handleClose();
        })
        .catch((err) => {
          if(err.toString()==="Error: Network Error")
          {
            history.push('/offline')
          }
          else
          {
            history.push('/400')
          }
      })
    } else {
      var Pincodes = {
        pincode: [...new Set(removeDuplicates(pincodes1))],
        name: `${name}`,
        category: `${serviceCategory}`,
      };

      axios
        .post(Baseurl.baseurl + `/go-service-area/add-service-area`, Pincodes)
        .then((response) => {
          if (response.data.status) {
            getData();
            swal("Added", response.data.message, "success", {
              button: "Done",
              timer: 1000,
            });
            setpincodes1([]);
          } else {
            swal("Oops", response.data.message, "error", {
              button: "Done",
              timer: 1000,
            });
          }
          handleClose();
        })
        .catch((err) => {
          if(err.toString()==="Error: Network Error")
          {
            history.push('/offline')
          }
          else
          {
            history.push('/400')
          }
      })
    }
  };
  function deleteServiceArea() {
    axios
      .delete(
        Baseurl.baseurl + `/go-service-area/delete-service-area/${serviceId}`
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
    setShow4(false);
  }
  function updateServiceArea() {
    var serviceData = {
      Name: `${serviceName}`,
      Category: `${serviceCategory}`,
    };
    axios
      .put(
        Baseurl.baseurl + `/go-service-area/update-service-area/${serviceId}`,
        serviceData
      )
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getData();
        handleClose2();
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  function handleShow1(id, name, area) {
    setServiceId(id);
    setUpdateService(true);
    setShow1(true);
    setServiceName(name);
    setServiceCategory(area);
  }
  function handleShow2(pincode) {
    setServicePincode(pincode);
    setShow1(true);
    setUpdateService(false);
  }
  function searchPincode(value) {
    let filteredData = [];
    forSearch.map((val) => {
      let pinString = val.id.toString();
      if (pinString.includes(value)) {
        filteredData.push(val);
      }
    });
    setshowdictpincodes(filteredData);
  }
  function searchDist(value) {
    let filteredData = [];
    districtForSearch.map((val) => {
      if (val.Name.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setstatepincodes(filteredData);
  }
  function searchState(value) {
    let filteredData = [];
    stateForSearch.map((val) => {
      if (val.State.toLowerCase().includes(value)) {
        filteredData.push(val);
      }
    });
    setpincodes(filteredData);
  }
  function distictSelect(id) {
    axios.get(Baseurl.baseurl + `/go-pincode/get-pincode/${id}`).then((res) => {
      setpincodes1((oldArray) => oldArray.concat(res.data.pincodes.PinCode));
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  return (
    <div className="row">
      <div className="col-xl-12 col-lg-12">
        <div className="card" style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}>
          <div className="card-header">
            <h4 className="card-title text-white">Add Serviceable Area</h4>
          </div>
          <Modal
            show={show4}
            onHide={() => {
              setShow4(false);
            }}
          >
            <Modal.Body>
              <h4>
                Are you sure !! you want to delete{" "}
                <text className="text-danger ml-1">{serviceName}</text>{" "}
              </h4>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => {
                  deleteServiceArea();
                }}
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal size="lg" show={show} onHide={handleClose}>
            {/* <Modal.Header closeButton>
                        </Modal.Header> */}
            <Modal.Body>
              {showdistricts == "true" && (
                <div className="row">
                  <div className="col-sm-8">
                    <button
                      className="btn btn-primary"
                      onClick={() => setitem("back")}
                    >
                      Back
                    </button>
                  </div>
                  <div className="col-sm-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here..."
                      onChange={(e) => {
                        searchDist(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}
              {showstates == "true" && (
                <div className="row">
                  <div className="col-sm-8"></div>
                  <div className="col-sm-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here..."
                      onChange={(e) => {
                        searchState(e.target.value);
                      }}
                    />
                  </div>
                </div>
              )}
              <Table id="myTable" responsive>
                {showdictpincodes1 == "true" ? (
                  <thead>
                    <tr>
                      <th>
                        <strong>Pincodes</strong>
                      </th>
                    </tr>
                  </thead>
                ) : (
                  <thead>
                    <tr>
                      {showstates == "true" ? (
                        <>
                          <th>
                            <strong> STATE NAME</strong>
                          </th>
                          <th>
                            <strong>View</strong>
                          </th>
                          <th>
                            <strong>Add</strong>
                          </th>
                        </>
                      ) : (
                        <>
                          <th></th>
                          <th>
                            <strong> DISTRICT NAME</strong>
                          </th>
                          <th>
                            <strong>View</strong>
                          </th>
                        </>
                      )}
                    </tr>
                  </thead>
                )}
                <tbody>
                  {showstates == "true" &&
                    pincodes &&
                    pincodes
                      .map((data, index) => {
                        if (duplicateCheck.includes(data.State)) return null;
                        duplicateCheck.push(data.State);
                        return (
                          <tr>
                            {data.State ? <td>{data.State} </td> : null}
                            {data.State ? (
                              <td>
                                <Link>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() =>
                                      setitem(data._id, data.State)
                                    }
                                  >
                                    View
                                  </button>
                                </Link>
                              </td>
                            ) : null}
                            {data.State ? (
                              <td>
                                <button
                                  className="btn btn-primary"
                                  onClick={() => setitemapi(data.State)}
                                >
                                  ADD
                                </button>
                              </td>
                            ) : null}
                          </tr>
                        );
                      })
                      .filter((e) => e)}
                  {showdistricts == "true" &&
                    statepincodes.map((d, i) => (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            onClick={() => distictSelect(d._id)}
                            className="mb-3"
                            id="checkAll"
                            required
                          />
                        </td>
                        <td>{d.Name} </td>
                        <td>
                          <button
                            className="btn btn-primary"
                            onClick={() => viewdict(d._id)}
                          >
                            View
                          </button>
                        </td>
                        {/* <td>
                          <button
                            className="btn btn-primary"
                            onClick={() => setitemapi(d._id, "dict")}
                          >
                            ADD
                          </button>
                        </td> */}
                      </tr>
                    ))}
                </tbody>
              </Table>
              {showdictpincodes1 == "true" && (
                <div>
                  <button
                    className="btn btn-primary mb-3"
                    onClick={() => {
                      setshowdictpincodes1("false");
                      setshowdistricts("true");
                    }}
                  >
                    Back
                  </button>
                  <div className="row mb-4">
                    <div className="col-sm-1 mt-2">
                      <label>
                        <strong>search</strong>
                      </label>
                    </div>
                    <div className="col-sm-3">
                      <input
                        value={search}
                        type="text"
                        className="form-control"
                        placeholder="Search Pincode"
                        onChange={(e) => {
                          setSearch(e.target.value);
                          searchPincode(e.target.value);
                        }}
                        required
                      />
                    </div>
                  </div>
                  {showdictpincodes.map((d, i) => (
                    <div className="row">
                      <tr>
                        <input
                          type="checkbox"
                          onClick={() => sub(d.id)}
                          className="mb-3"
                          id="checkAll"
                          required
                        />
                      </tr>
                      <tr className="ml-5">{d.id}</tr>
                    </div>
                  ))}
                  <button className="btn btn-primary" onClick={() => addPin()}>
                    ADD
                  </button>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              {showdistricts == "true" && (
                <Button
                  variant="primary"
                  onClick={() => {
                    addPin();
                  }}
                >
                  ADD
                </Button>
              )}
              <Button variant="secondary" onClick={handleClose1}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal size="lg" show={show1} onHide={handleClose2}>
            <Modal.Body>
              <div className="card-body">
                <div className="col-sm-12">
                  <div className="row">
                    <div className="col-sm-12">
                      {updateService ? (
                        <div className="form-group row">
                          <div className="col-sm-4  mt-2" id="multiselect">
                            <label>Category</label>
                            <Multiselect
                              options={objectArray1}
                              singleSelect
                              displayValue="category"
                              onSelect={selection2}
                              placeholder={serviceCategory}
                            />
                          </div>
                          <div className="col-sm-4">
                            <label>Name</label>
                            <input
                              value={serviceName}
                              type="text"
                              className="form-control"
                              placeholder="Area Name"
                              onChange={(e) => setServiceName(e.target.value)}
                              required
                            />
                          </div>
                          <div className="mt-3">
                            <Link>
                              <button
                                onClick={() => {
                                  updateServiceArea();
                                }}
                                className="btn btn-info ml-4 mt-2"
                              >
                                Update
                              </button>
                            </Link>
                          </div>
                        </div>
                      ) : (
                        <Table responsive className="table table-striped">
                          <thead>
                            <tr>
                              <th>
                                <strong>Pincodes</strong>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {servicePincode &&
                              servicePincode.map((i) => (
                                <tr>
                                  <td>{i}</td>
                                </tr>
                              ))}
                          </tbody>
                        </Table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <div className="card-body">
            <div className="col-sm-12">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group row">
                    <div className="col-sm-4" id="multiselect">
                      <label>Category</label>
                      <select
                        className="form-control"                                                  
                        onChange={(e) => setServiceCategory(e.target.value)}
                        required
                      >
                        <option value="">--Select Category--</option>
                        {objectArray1.map((d) => (
                          <option value={d}>{d}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-4 mb-5">
                      <label>Name</label>
                      <input
                        value={name}
                        type="text"
                        className="form-control"
                        placeholder="Area Name"
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mt-1">
                      <Link>
                        <button
                          onClick={() => handleShow("addNew")}
                          className="btn btn-primary ml-5 mt-4"
                        >
                          Add
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            
                  <div id="job_data" className="dataTables_wrapper ">
                    {spinner ? (
                      <div className="text-center">
                        <Spinner animation="border" variant="primary" />
                      </div>
                    ) : (
                      <Table responsive className="table text-white">
                        <thead>
                          <tr>
                            <th>
                              <strong>Slno.</strong>
                            </th>
                            <th>
                              <strong>NAME</strong>
                            </th>
                            <th>
                              <strong>Category</strong>
                            </th>
                            <th>
                              <strong>Update Pincode</strong>
                            </th>
                            <th>
                              <strong>Actions</strong>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {serviceData &&
                            serviceData.map((i, key) => (
                              <tr>
                                <td>{key + 1}</td>
                                <td>{i.Name}</td>
                                <td>{i.Category}</td>
                                <td>
                                  {" "}
                                  <Link
                                    onClick={() => {
                                      handleShow("addExist", i._id);
                                    }}
                                    href="#"
                                    className="btn btn-secondary shadow btn-xs sharp ml-5"
                                  >
                                    <i className="fa fa-plus-square"></i>
                                  </Link>
                                </td>
                                <td>
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="warning"
                                      className="light sharp i-false"
                                    >
                                      {svg1}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() => {
                                          handleShow1(
                                            i._id,
                                            i.Name,
                                            i.Category
                                          );
                                        }}
                                      >
                                        Update
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={() => {
                                          setShow4(true);
                                          setServiceId(i._id);
                                          setServiceName(i.Name);
                                        }}
                                      >
                                        Delete
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        onClick={() => {
                                          handleShow2(i.Pincode);
                                        }}
                                      >
                                        View Geofence
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                                {/* <td>{i.Name }</td> */}
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    )}

                    {!serviceData && (
                      <Alert
                        variant="success"
                        className="alert-dismissible fade show text-center"
                      >
                        Add Serviceable Area
                      </Alert>
                    )}
                    <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                      <div className="dataTables_info text-white">
                        Showing {activePag.current * sort + 1} to{" "}
                        {data.length > (activePag.current + 1) * sort
                          ? (activePag.current + 1) * sort
                          : data.length}{" "}
                        of {data.length} entries
                      </div>
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="example5_paginate"
                      >
                        <Link
                          className="paginate_button previous disabled"
                          onClick={() =>
                            activePag.current > 0 &&
                            onClick(activePag.current - 1)
                          }
                        >
                          Previous
                        </Link>
                        <span>
                          {paggination.map((number, i) => (
                            <Link
                              key={i}
                              className={`paginate_button  ${
                                activePag.current === i ? "current" : ""
                              } `}
                              onClick={() => onClick(i)}
                            >
                              {number}
                            </Link>
                          ))}
                        </span>
                        <Link
                          className="paginate_button next"
                          onClick={() => {
                            activePag.current + 1 < paggination.length &&
                              onClick(activePag.current + 1);
                          }}
                        >
                          Next
                        </Link>
                      </div>
                    </div>
                  </div>
                
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
